import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Button } from 'wix-style-react'
import DeleteIcon from 'react-icons/lib/md/delete'

import { LIGHT_GRAY, RED } from 'components/styles'

const Image = styled.img`
  max-width: 100%;
  max-height: 100%;
  vertical-align: middle;
`
const FileCard = styled.div`
  position: relative;
  margin-top: 1em;
  margin-bottom: 1em;
  width: 16%;
  height: 100%;
  text-align: center;
  margin-left: 1em;
  line-height: 1em;
  border: solid 1px ${LIGHT_GRAY};
`

const DeleteImageButtonContainer = styled.div`
  position: absolute;
  right: 0em;
  bottom: 0em;
`

class ProductImage extends Component {

  constructor (props) {
    super(props)
    this.state = {
      hover: false
    }
  }

  renderButton = () => {
    const { onDelete } = this.props
    if (this.state.hover) {
      return (
        <DeleteImageButtonContainer>
          <Button theme='icon-whitesecondary' onClick={onDelete}>
            <DeleteIcon size='24' color={RED} />
          </Button>
        </DeleteImageButtonContainer>
      )
    }
  }

  render () {
    const { src } = this.props
    return (
      <FileCard
        onMouseEnter={() => this.setState({hover: true})}
        onMouseLeave={() => this.setState({hover: false})}
      >
        <Image src={src} />
        {this.renderButton()}
      </FileCard>
    )
  }

}

ProductImage.defaultProps = {
  onDelete: () => null
}

ProductImage.propTypes = {
  src: PropTypes.string.isRequired,
  onDelete: PropTypes.func
}

export default ProductImage



// WEBPACK FOOTER //
// ./src/components/shared/addProduct/ProductImage.js